<div class="success__popin">
  <vc-sprite-icons class="success__popin__icon" name="check"></vc-sprite-icons>
  <div class="success__popin__text vc-text-m">
    <div [ngSwitch]="data?.form">
      <div *ngSwitchCase="formEnum.PERSONAL_INFORMATION" i18n="@@GET_PAID.SUCCESS_POPIN.PERSONAL_INFORMATION">
        Personal information saved.
      </div>
      <div *ngSwitchCase="formEnum.TRANSFERT_METHOD" i18n="@@GET_PAID.SUCCESS_POPIN.TRANSFER_METHOD">
        Transfer method saved.
      </div>
      <div *ngSwitchCase="formEnum.VERIFICATION" i18n="@@GET_PAID.SUCCESS_POPIN.IDENTITY_VERIFICATION">
        Identity verification done.
      </div>
    </div>
  </div>
  <div class="success__popin__text vc-text-m" i18n="@@GET_PAID.REASSURANCE.ALL_DONE.REGARDS">
    Thank you!
  </div>
</div>
